<template>
  <section-meta
    :count="browsers.length"
    label="Browsers"
    intro="All browsers affected by this card."
  >
    <item-browser v-for="b in browsers" :browser="b" :key="b.id" />
  </section-meta>
</template>

<script>
import { mapActions } from '@picnic-software/vuex'

import ButtonIcon from '@/components/buttons/ButtonIcon'
import SectionMeta from '@/components/SectionMeta'
import ItemBrowser from '@/components/items/ItemBrowser'
import '@/icons/add'

export default {
  name: 'CardSectionsBrowsers',
  props: {
    browsers: {
      type: Array,
      default: () => []
    }
  },
  components: {
    ItemBrowser,
    SectionMeta,
    ButtonIcon
  },
  async created() {
    await this.assignBrowser()
  },
  methods: {
    ...mapActions({
      assignBrowser: 'browser/assign'
    })
  }
}
</script>
